"use client";
import ProjectCard from "@/components/ui/ProjectCard";
import { useAppContext } from "@/providers/AppProvider";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const containerVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const fadeUpVariants = {
    hidden: { opacity: 0.5, y: -10 },
    visible: { opacity: 1, y: 0 },
};

function Projects() {
    const { projects } = useAppContext();
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [availableCategories, setAvailableCategories] = useState<string[]>(
        [],
    );
    const filteredProjects =
        selectedCategory === "All"
            ? projects
            : projects.filter(
                  (project) => project.category === selectedCategory,
              );

    useEffect(() => {
        const categories = projects.map((project) => project.category);
        setAvailableCategories(["All", ...new Set(categories)]);
    }, [projects]);

    return (
        <motion.section
            className="p-2"
            initial="hidden"
            animate="visible"
            viewport={{
                once: false,
            }}
            variants={containerVariants}
        >
            <motion.h2
                variants={fadeUpVariants}
                className="mb-4 text-3xl font-bold text-primary lg:text-4xl"
            >
                Projects
            </motion.h2>
            <motion.div
                variants={fadeUpVariants}
                className="mb-4 flex flex-wrap gap-4"
            >
                {availableCategories.map((category) => (
                    <motion.button
                        key={category}
                        onClick={() => setSelectedCategory(category)}
                        variants={fadeUpVariants}
                        className={`rounded-lg border-2 px-4 py-1 text-sm ${
                            selectedCategory === category
                                ? "border-primary text-primary"
                                : "border-border-color"
                        }`}
                    >
                        {category}
                    </motion.button>
                ))}
            </motion.div>
            <motion.div
                className="grid-cols-autofit grid gap-4"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.1, once: true }}
            >
                {filteredProjects.map((project, index) => (
                    <motion.div key={index} variants={fadeUpVariants}>
                        <ProjectCard project={project} />
                    </motion.div>
                ))}
            </motion.div>
        </motion.section>
    );
}

export default Projects;
